import { AggregationMode, TimeInterval, IPeriodConfiguration, PeriodReference, RowSpacing, Limit, DateOrder } from '../../models';
import { IPresentationUnitConfiguration } from '../models/interfaces';
import { TableByGroupWidgetSeries } from './tableByGroup.series';

export class TableByGroupWidgetConfiguration implements IPeriodConfiguration {
    aggregationMode: AggregationMode;
    aggregationRowMode: AggregationMode;
    alignedOn: PeriodReference;
    groupGuidCollection: string[];
    groupTypes: string[];
    hasAggregationRow?: boolean;
    hasAlarm: boolean;
    hasLegend: boolean;
    hasName: boolean;
    hasQuality: boolean;
    hasShortComment: boolean;
    hasUnits: boolean;
    hasValueType: boolean;
    hideFieldDescription: boolean;
    hideFieldDescriptions?: boolean;
    isBoundToGroup: boolean;
    isEndDateIncluded = false;
    isTypeVisible: boolean;
    limit: Limit;
    maxItems: number;
    maxPeriod: TimeInterval;
    minPeriod: TimeInterval;
    options: IPresentationUnitConfiguration;
    rowSpacing: RowSpacing;
    isSearchByRelativePath?: boolean;
    series: TableByGroupWidgetSeries[];
    showGroupLongComment: boolean;
    showGroupName: boolean;
    showGroupShortComment: boolean;
    sortBy: string;
    sortOrder: DateOrder;

    constructor() {
        this.aggregationMode = AggregationMode.Average;
        this.series = [];
        this.aggregationRowMode = AggregationMode.Sum;
        this.hasLegend = false;
        this.hasName = true;
        if (!this.groupGuidCollection) {
            this.groupGuidCollection = [];
        }
        this.rowSpacing = RowSpacing.Normal;
        this.alignedOn = PeriodReference.End;
        this.sortBy = '';
        this.sortOrder = DateOrder.Increasing;
        this.limit = Limit.None;
        this.maxItems = 10;
        this.hasUnits = false;
        this.isSearchByRelativePath = false;
    }
}